const Text = ({ component, text, classes, id, children}) => {

    // The tag name must be a capitalized 
    const Tag = component;
    const mainClasses = "";

    return (
        <Tag id={id} className={`${mainClasses} ${classes}`}>{text? text: children}</Tag>
    )
}

Text.defaultProps = {
    component: 'p',
    classes: ""
}

export default Text;